import { render } from "./TeacherHome.vue?vue&type=template&id=4395070b&scoped=true"
import script from "./TeacherHome.vue?vue&type=script&lang=js"
export * from "./TeacherHome.vue?vue&type=script&lang=js"

import "./TeacherHome.vue?vue&type=style&index=0&id=4395070b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4395070b"]])

export default __exports__